import { clearUserCookie } from '@/utils/cookie'
import { message } from 'antd'
import axios, { AxiosRequestConfig } from 'axios'
import { cacheAdapterEnhancer, throttleAdapterEnhancer } from 'axios-extensions'
import { Config, IS_ELECTRON } from '../utils/config'
import { ipcSendAction } from '../utils/electron'
import { getUserToken } from '../utils/user'

interface IApiResData {
  message: string
  result: number
  data: any
}

interface IOptions extends AxiosRequestConfig {
  noMsg?: boolean
}

export const instance = axios.create({
  baseURL: Config.baseUrl,
  headers: { 'Cache-Control': 'no-cache' },
  timeout: 100000,
  //  开启 throttle & cache 控制请求
  // defaultCache	CacheLike	new LRUCache({ maxAge: FIVE_MINUTES, max: 100 })

  //
  adapter: throttleAdapterEnhancer(
    // 这里是缓存时指 页面周期内，页面刷新重载入是相当于重新请求
    cacheAdapterEnhancer(axios.defaults.adapter!, {
      enabledByDefault: false,
      cacheFlag: 'useCache',
    })
  ),
})

const isNewVserionResponse = (apiRsData: IApiResData) => {
  return 'data' in apiRsData && 'message' in apiRsData && 'result' in apiRsData
}

const errResultMsg = (apiRsData: IApiResData) => {
  //TODO 解决slack 报错
  if (apiRsData.message === 'Please activate slack first') {
    return
  }
  message.error(apiRsData.message)
}

// request 拦截器
// eslint-disable-next-line
const requestInterceptors = instance.interceptors.request.use(
  (config) => {
    // config.data = JSON.stringify(config.data);
    const token = getUserToken()
    config.headers.Authorization = `Bearer ${token}`
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// response 拦截器
// eslint-disable-next-line
const responseInterceptors = instance.interceptors.response.use(
  (response) => {
    if (response.data.errCode === 2) {
      // 通知Electron端 用户token过期
      ipcSendAction('logout', {
        clearCookie: true,
      })
      // router.push({
      // 	path: "/login",
      // 	querry: {redirect: router.currentRoute.fullPath}//从哪个页面跳转
      // })
    }

    // 是否是新标准的接口数据返回
    const apiRsData = response.data

    if (isNewVserionResponse(apiRsData)) {
      // console.log('[new version api]: ', response.request.responseURL)
      if (apiRsData['result'] !== 0) {
        return Promise.reject(apiRsData)
      }
      return apiRsData
    }
    return response
  },
  (error) => {
    return Promise.reject(error)
  }
)

// export function removeRequestInterceptors () {
//   instance.interceptors.request.eject(requestInterceptors)
// }
// export function removeResponseInterceptors () {
//   instance.interceptors.request.eject(responseInterceptors)
// }

/**
 * 封装get方法
 * @param url
 * @param params
 * @param options : { noMsg : boolean : 报错不显示消息弹框 }
 * @returns {Promise}
 */

export function get(url: string, params: object = {}, options: IOptions = {}) {
  return new Promise((resolve, reject) => {
    instance
      .get(url, {
        ...options,
        params: params,
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((err) => {
        msag(err, options)
        if (isNewVserionResponse(err) && !options.noMsg) {
          errResultMsg(err)
        }
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @param options : { noMsg : boolean : 报错不显示消息弹框 }
 * @returns {Promise}
 */

export function post(url: string, data = {}, options: IOptions = {}) {
  return new Promise((resolve, reject) => {
    instance.post(url, data, options).then(
      (response) => {
        //关闭进度条
        resolve(response.data)
      },
      (err) => {
        msag(err, options)
        if (isNewVserionResponse(err) && !options.noMsg) {
          errResultMsg(err)
        }
        reject(err)
      }
    )
  })
}

function msag(err: any, options: any) {
  // 有些不需要报错
  if (options.noMsg) {
    return
  }
  if (err && err.response) {
    console.log(err.response.status)

    switch (err.response.status) {
      case 400:
        message.error('Bad request!')
        break
      case 401:
        message.error('Unauthorized: Please log in!')
        // 清除 token
        clearUserCookie()
        if (IS_ELECTRON) {
          // 通知Electron端 用户token过期
          ipcSendAction('logout', {
            clearCookie: true,
          })
        } else {
          // 跳到前台首页登录 (curl 登录成功跳转地址)
          const loginUrl = `${Config.LOGIN_URL}?curl=${encodeURI(window.location.href)}`
          window.location.href = loginUrl
        }

        break

      case 403:
        message.error('Access Denied!')
        break

      case 404:
        message.error('Bad Address!')
        break

      case 408:
        message.error('Request Timeout!')
        break

      case 423:
        // 用户被冻结
        message.error('Your account has been disabled. To regain access please contact your admin.')
        // 清除 token
        clearUserCookie()
        setTimeout(() => {
          // 跳到前台首页登录 (curl 登录成功跳转地址)
          const loginUrl = `${Config.LOGIN_URL}?curl=${encodeURI(window.location.href)}`
          window.location.href = loginUrl
        }, 2000)
        break

      case 500:
        message.error('Internal Server Error!')
        break

      case 501:
        message.error('Not yet implemented!')
        break

      case 502:
        message.error('Bad Gateway!')
        break

      case 503:
        message.error('Service Unavailable!')
        break

      case 504:
        message.error('Gateway Timeout!')
        break

      case 505:
        message.error('HTTP Version Not Supported!')
        break
      default:
    }
  }
}
